module.exports = __webpack_public_path__ + "img/nav-payslips.c8f1ea1d.svg";